
import { Card, CardContent } from "@/components/ui/card";
import { Building2, UserRound } from "lucide-react";
import { type RegistrationType } from "@/hooks/use-registration-flow";

interface RegistrationTypeSelectorProps {
  selectedType: RegistrationType;
  onTypeSelect: (type: RegistrationType) => void;
}

export function RegistrationTypeSelector({ selectedType, onTypeSelect }: RegistrationTypeSelectorProps) {
  return (
    <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
      <button
        onClick={() => onTypeSelect("PF")}
        className={`w-full text-left transition-all ${
          selectedType === "PF"
            ? "ring-2 ring-drcash-caribbean-green"
            : "hover:shadow-md"
        }`}
      >
        <Card>
          <CardContent className="p-6">
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-drcash-caribbean-green/10 flex items-center justify-center">
                <UserRound className="w-6 h-6 text-drcash-caribbean-green" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-lg mb-2">Credenciamento Pessoa Física</h3>
                <p className="text-sm text-gray-600">
                  Apenas para Dentistas que não possuem CNPJ
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </button>

      <button
        onClick={() => onTypeSelect("PJ")}
        className={`w-full text-left transition-all ${
          selectedType === "PJ"
            ? "ring-2 ring-drcash-caribbean-green"
            : "hover:shadow-md"
        }`}
      >
        <Card>
          <CardContent className="p-6">
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-drcash-caribbean-green/10 flex items-center justify-center">
                <Building2 className="w-6 h-6 text-drcash-caribbean-green" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-lg mb-2">
                  Credenciamento Pessoa Jurídica (CNPJ)
                </h3>
                <p className="text-sm text-gray-600">
                  Apenas para empresas que possuem CNPJ (inclusive dentistas)
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </button>
    </div>
  );
}
